<template>
  <v-navigation-drawer
    :value="$root.rightNav"
    fixed
    right
    app
    hide-overlay
    disable-resize-watcher
    class="pt-0"
  >
    <v-container>
      <v-layout column>
        <loading-block
          style="margin:10px; height:60px;"
          v-if="!loaded"
        ></loading-block>
        <v-list dense>
          <template v-for="loc in vg_locationList">
            <v-list-item
              class="mt-2"
              :key="loc.location_id"
              v-if="vg_selectedLocation.id === loc.id"
            >
              <v-list-item-title>
                {{ loc.name }}
              </v-list-item-title>
              <v-list-item-action>
                <v-btn
                  x-small
                  color="primary"
                  elevation="0"
                  fab
                  style="min-height: 16px; height:16px; min-width: 16px; width:16px; font-size:10px;"
                  @click.prevent="removeLocation()"
                >
                  <v-icon>remove</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-list-item
              class="mt-2"
              :key="loc.location_id"
              @click.prevent="
                vg_selectedLocation.id === loc.id ? '' : setLocation(loc)
              "
              v-else
            >
              <v-list-item-title>{{ loc.name }}</v-list-item-title>
              <v-list-item-action></v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-layout>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
export default {
  components: {
    LoadingBlock
  },
  data: () => {
    return {
      allStores: [],
      loaded: false
    }
  },
  props: {
    open: {
      default: false,
      required: true
    }
  },
  watch: {
    async '$root.rightNav'(value) {
      if (value === true) {
        this.loaded = false
        try {
          await this.va_setUserLocationList()
          this.loaded = true
        } catch (err) {
          this.loaded = true
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      vm_removeLocations: 'auth/REMOVE_LOCATIONS'
    }),
    ...mapActions({
      va_setActiveLocation: 'auth/setUsersLocation',
      va_setUserLocationList: 'auth/setUserLocationList',
      va_fetchAllTable: 'table/fetchAll'
    }),
    async setLocation(obj) {
      await this.va_setActiveLocation(obj.id)
      this.snackbar({
        text: 'Location selected.',
        color: 'success'
      })
      this.$root.rightNav = false
      if (this.$router.currentRoute.name !== 'Table') {
        this.$router.push({ name: 'Table' })
      } else {
        this.va_fetchAllTable()
      }
    },
    /**
     * Remove current selected location
     */
    removeLocation() {
      this.spinner(true)
      this.vm_removeLocations()
      this.spinner(false)
      this.$root.rightNav = false
      this.snackbar({
        text: 'Location removed.',
        color: 'success'
      })
      this.$router.push({ name: 'Home' })
    }
  },
  computed: {
    ...mapGetters({
      vg_activeBusiness: 'auth/activeBusiness',
      vg_locationList: 'auth/locationsList',
      vg_selectedLocation: 'auth/selectedLocation'
    })
  }
}
</script>
<style>
.selectedLocation {
  background: var(--v-primary-base);
}
.item-right .v-list__tile {
  flex-direction: row;
  justify-content: flex-end;
}
</style>
